"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const batch_1 = require("./batch");
const consts_1 = require("./consts");
const hooks_1 = require("./hooks");
const subscriber_1 = require("./subscriber");
const utils_1 = require("./utils");
/* CHANGES SUBSCRIBER */
class ChangesSubscriber extends subscriber_1.default {
    /* CONSTRUCTOR */
    constructor(store) {
        super();
        this._sschedule = super.schedule.bind(this);
        this.store = store;
    }
    /* API */
    schedule(paths) {
        this.paths ? this.paths.push(...paths) : (this.paths = paths.slice());
        if (batch_1.default.isActive())
            return batch_1.default.schedule(this._sschedule);
        return super.schedule();
    }
    trigger() {
        const paths = this.paths || consts_1.EMPTY_ARRAY, roots = utils_1.default.uniq(utils_1.default.paths.rootify(paths));
        this.paths = undefined;
        hooks_1.default.store.changeBatch.trigger(this.store, paths, roots);
        super.trigger(roots);
    }
}
/* EXPORT */
exports.default = ChangesSubscriber;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhbmdlc19zdWJzY3JpYmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NoYW5nZXNfc3Vic2NyaWJlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQ0EsWUFBWTs7QUFFWixtQ0FBNEI7QUFDNUIscUNBQXFDO0FBQ3JDLG1DQUE0QjtBQUM1Qiw2Q0FBc0M7QUFDdEMsbUNBQTRCO0FBRzVCLHdCQUF3QjtBQUV4QixNQUFNLGlCQUFrQixTQUFRLG9CQUFzQjtJQVFwRCxpQkFBaUI7SUFFakIsWUFBYyxLQUFZO1FBRXhCLEtBQUssRUFBRyxDQUFDO1FBTkQsZUFBVSxHQUFHLEtBQUssQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFHLElBQUksQ0FBRSxDQUFDO1FBUWxELElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO0lBRXJCLENBQUM7SUFFRCxTQUFTO0lBRVQsUUFBUSxDQUFHLEtBQWU7UUFFeEIsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUcsR0FBRyxLQUFLLENBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBRSxJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQyxLQUFLLEVBQUcsQ0FBRSxDQUFDO1FBRTVFLElBQUssZUFBSyxDQUFDLFFBQVEsRUFBRztZQUFHLE9BQU8sZUFBSyxDQUFDLFFBQVEsQ0FBRyxJQUFJLENBQUMsVUFBVSxDQUFFLENBQUM7UUFFbkUsT0FBTyxLQUFLLENBQUMsUUFBUSxFQUFHLENBQUM7SUFFM0IsQ0FBQztJQUVELE9BQU87UUFFTCxNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsS0FBSyxJQUFJLG9CQUFXLEVBQ2pDLEtBQUssR0FBRyxlQUFLLENBQUMsSUFBSSxDQUFHLGVBQUssQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFHLEtBQUssQ0FBRSxDQUFFLENBQUM7UUFFM0QsSUFBSSxDQUFDLEtBQUssR0FBRyxTQUFTLENBQUM7UUFFdkIsZUFBSyxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsT0FBTyxDQUFHLElBQUksQ0FBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLEtBQUssQ0FBRSxDQUFDO1FBRTdELEtBQUssQ0FBQyxPQUFPLENBQUcsS0FBSyxDQUFFLENBQUM7SUFFMUIsQ0FBQztDQUVGO0FBRUQsWUFBWTtBQUVaLGtCQUFlLGlCQUFpQixDQUFDIn0=